// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3XuAh","head":"Table_head__3XEtv","col":"Table_col__j5VHf"};